
import * as ReportActions from './actions';
import { createReducer, on, Action } from '@ngrx/store';
import { State, initializeReportState } from './state';

export const intialState = initializeReportState();

const reducer = createReducer(
  intialState,
  on(ReportActions.BeginGetReportTypesByProjectTypeAction, state => state),
  on(ReportActions.ReportTypesLoadedAction, (state: State, { payload }) => {
    return {
      ...state,
      reports: payload
    };
  }),
  on(ReportActions.BeginGetVersionsByReportTypeAction, (state: State, { payload }) => {
    return {
      ...state,
      versions: []
    };
  }),
  on(ReportActions.VersionsLoadedAction, (state: State, { payload }) => {
    return {
      ...state,
      versions: payload
    };
  }),
  on(ReportActions.BeginGetReportsProgressAction, state => state),
  on(ReportActions.GetReportProgressSuccessAction, (state: State, { payload }) => {
    return {
      ...state,
      progress: payload
    };
  }),
  on(ReportActions.BeginCreateReportTypeAction, state => state),
  on(ReportActions.SuccessCreateReportTypeAction, (state: State, { payload }) => {
    return {
      ...state,
      reports: [payload.reportType, ...state.reports],
      selectedReportType: payload.reportType
    };
  }),
  on(ReportActions.BeginGenerateReportAction, state => state),
  on(ReportActions.GenerateReportSuccessAction, (state: State, { payload: { createdReport } }) => {
    return {
      ...state,
      versions: [createdReport, ...state.versions]
    };
  }),
  on(ReportActions.SelectReportTypeAction, (state: State, { payload }) => {
    return {
      ...state,
      selectedReportType: payload.reportType
    };
  })
);
export function ReportTypeReducer(state: State | undefined, action: Action) {
  return reducer(state, action);
}
